<div box>
  <div title>Two Factor Authentication</div>
  <div>
    <!-- Method Selector Tabs when both are enabled -->
    <div *ngIf="isGoogleAuth && isEmailAuth" class="flex mb-6 border-b border-gray-200">
      <button 
        type="button"
        class="flex-1 py-2 px-4 text-center font-medium text-sm border-b-2 transition-colors duration-200"
        [class.border-blue-600]="activeAuthMethod === 'GOOGLE'"
        [class.text-blue-600]="activeAuthMethod === 'GOOGLE'"
        [class.border-transparent]="activeAuthMethod !== 'GOOGLE'"
        [class.text-gray-500]="activeAuthMethod !== 'GOOGLE'"
        (click)="selectMethod('GOOGLE')"
      >
        Google Authenticator
      </button>
      <button 
        type="button"
        class="flex-1 py-2 px-4 text-center font-medium text-sm border-b-2 transition-colors duration-200"
        [class.border-blue-600]="activeAuthMethod === 'EMAIL'"
        [class.text-blue-600]="activeAuthMethod === 'EMAIL'"
        [class.border-transparent]="activeAuthMethod !== 'EMAIL'"
        [class.text-gray-500]="activeAuthMethod !== 'EMAIL'"
        (click)="selectMethod('EMAIL')"
      >
        Email Verification
      </button>
    </div>

    <div class="pt-2 pb-6 text-left text-gray-600">
      <div *ngIf="activeAuthMethod === 'GOOGLE' || (isGoogleAuth && !isEmailAuth)">
        Open your Google Authenticator app and enter the 6-digit code.
      </div>
      <div *ngIf="activeAuthMethod === 'EMAIL' || (!isGoogleAuth && isEmailAuth)">
        A verification code has been sent to <strong>{{ email }}</strong>. Please enter the code below.
      </div>
    </div>

    <form nz-form [formGroup]="form" (ngSubmit)="submitForm()">
      <nz-form-item>
        <nz-form-control nzErrorTip="Required">
          <nz-input-group nzPrefixIcon="number" nzSize="large">
            <input type="text" nz-input formControlName="code" placeholder="Enter 6-digit code" autocomplete="off" />
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
      <button [nzLoading]="isLoading" nzSize="large" nz-button nzBlock nzType="primary">Verify & Log In</button>
      
      <div class="text-center pt-4">
        <a *ngIf="activeAuthMethod === 'EMAIL'" class="mr-4 text-blue-600 hover:underline cursor-pointer" (click)="doResendCode()">Resend email code</a>
        <a [routerLink]="['/', 'login']" class="text-gray-500 hover:underline">Back to login</a>
      </div>
    </form>
  </div>
</div>
